import { OktaSignIn } from '../classic';

// CDN bundle must have a single default export
export default OktaSignIn;
